<template>
  <div class="index_background" style="padding: 20px">
    <el-dialog :title="'用户协议'" :visible.sync="isShow">
      <div v-html="textHtml"></div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="refuse">暂时不同意</el-button>
        <el-button type="primary" @click="confirm">同意</el-button>
      </div>
    </el-dialog>
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      v-if="registerForm"
    >
      <h5 align="center">合同签署平台注册</h5>
      <el-form-item label="登录账号" prop="mobile">
        <el-input v-model="ruleForm.mobile" autocomplete="off" placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="邮箱" prop="emailAddr">
        <el-input v-model="ruleForm.emailAddr" autocomplete="off" placeholder="请输入您的有效邮箱地址"></el-input>
      </el-form-item>
      <el-form-item label="密码" prop="pwd">
        <el-input type="password" v-model="ruleForm.pwd" placeholder="请输入6-16位数字字母、特殊字符组合（区分大小写）"></el-input>
      </el-form-item>
      <el-form-item label="确认密码" prop="checkPwd">
        <el-input type="password" v-model="ruleForm.checkPwd" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="用户类型" prop="accountType">
        <el-select v-model="ruleForm.accountType" placeholder="请选择用户类型" readonly="true">
          <el-option label="企业" value="2"></el-option>
          <el-option label="个人" value="1"></el-option>
        </el-select>
        <!-- <el-input v-model="ruleForm.accountType" autocomplete="off" readonly="true"></el-input> -->
      </el-form-item>
      <el-form-item label="验证码" prop="vcode">
        <el-input v-model="ruleForm.vcode"></el-input>
        <img id="verImg" :src="vcode_img" width="130px" height="48px" />
        <a class="refreshCode" @click="refreshCode()" style="color:red">看不清?换一张</a>
      </el-form-item>

      <el-form-item prop="agreement">
        <el-button type="primary" @click="submitForm('ruleForm')">立即注册</el-button>
        <el-button type="success" @click="authentic('ruleForm')">实名认证</el-button>
        <el-button type="info" @click="toLogin">去登录</el-button>
        <el-checkbox-group class="checkbox" v-model="ruleForm.agreement">
          <!-- <el-checkbox :checked="checked == true" v-model="checked" label="" name="agreement">
            <span style="color: #9ea0a3"
              >同意 <router-link style="color: black" :to="{ path: '/userAgreement' }">《使用协议》</router-link>及
              <router-link style="color: black" :to="{ path: '/privacyPolicy' }">《隐私政策》</router-link></span
            >
          </el-checkbox> -->
        </el-checkbox-group>
      </el-form-item>
      <!-- `checked` 为 true 或 false -->
      <!-- <el-checkbox v-model="ruleForm.checked">《使用协议》 </el-checkbox> -->
      <el-checkbox-group class="checkbox" v-model="ruleForm.agreement">
        <el-checkbox :checked="checked == true" v-model="checked" label="" name="agreement">
          <span style="color: #9ea0a3"
            >已阅读并同意 <router-link style="color: black" :to="{ path: '/userAgreement' }">《使用协议》</router-link>及
            <router-link style="color: black" :to="{ path: '/privacyPolicy' }">《隐私政策》</router-link></span
          >
        </el-checkbox>
      </el-checkbox-group>

      <!-- <el-form-item label="协议" prop="agreement"> </el-form-item> -->
    </el-form>
  </div>
</template>

<script>
//注册接⼝
import { registerApi } from '@/api/getData.js'
//import SIdentify from '../../components/IdentifyCode'
import { getCompanyVerifyUrlApi } from '@/api/getData.js'
import { encrypt } from '@/utils/jsencrypt.js'
import { makeCodeApi } from '@/api/getData.js'
import md5 from 'js-md5'
//import userAgreement from '../../views/Agreement/UserAgreement'
import { getAnnouncementTextApi } from '../../api/getData'

export default {
  components: {},
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        //以下密码复杂性校验正式环境再开放
        var passwordreg = /(?=.*\d)(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{6,16}/
        if (!passwordreg.test(value)) {
          callback(new Error('密码必须由数字、字母、特殊字符组合,请输入6-16位'))
        }
        if (this.ruleForm.checkPwd !== '') {
          this.$refs.ruleForm.validateField('checkPwd')
          callback()
        }
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.ruleForm.pwd) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      identifyCode: '',
      vcode_img: '',
      verKey: '',
      ruleForm: {
        mobile: '',
        emailAddr: '',
        pwd: '',
        checkPwd: '',
        accountType: '',
        vcode: '',
        agreement: []
      },
      rules: {
        mobile: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { min: 6, max: 11, message: '长度6-11个字符', trigger: 'blur' }
        ],
        emailAddr: [
          { required: true, message: '请输入有效的邮箱地址', trigger: 'blur' },
          { min: 8, message: '长度过短', trigger: 'blur' }
        ],
        pwd: [{ required: true, validator: validatePass, trigger: 'blur' }],
        checkPwd: [{ required: true, validator: validatePass2, trigger: 'blur' }],
        accountType: [{ required: true, message: '请选择用户类型', trigger: 'change' }],
        vcode: [{ required: true, message: '请输入验证码', trigger: 'change' }],
        agreement: [{ type: 'array', required: true, message: '请阅读并同意《使用协议》及《隐私政策》', trigger: 'change' }]
      },
      loading: false,
      checked: false,
      isShow: true,
      textHtml: '',
      registerForm: false
    }
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.loading = true
          //调用注册接口
          var salt = this.ruleForm.mobile.substring(2, 6)
          var password = md5(salt + this.ruleForm.pwd + salt)
          //需要RSA加密
          let rsapwd = encrypt(password)
          //console.info(password)
          //console.info(md5(salt + this.ruleForm.pwd + salt))
          registerApi(this.ruleForm.mobile, this.ruleForm.emailAddr, rsapwd, this.ruleForm.accountType, this.ruleForm.vcode, this.verKey).then(res => {
            res = res.data
            if (res.code === 0) {
              this.$confirm('注册成功，是否去实名认证?', '提示', {
                confirmButtonText: '是',
                cancelButtonText: '取消',
                type: 'warning'
              })
                .then(() => {
                  //实名认证
                  //this.toAuth()
                  this.$router.push({ name: 'authentic' })
                })
                .catch(() => {
                  this.$message({
                    type: 'info',
                    message: '已取消'
                  })
                  this.refreshCode()
                })
              //this.toLogin()
            } else {
              this.$message({
                type: 'warning',
                message: '注册失败,' + res.msg
              })
              this.refreshCode()
            }
            this.loading = false
          })
        } else {
          this.$message({
            type: 'warning',
            message: '填写信息有误，请检查!'
          })
          this.refreshCode()
          return false
        }
      })
    },

    getTest() {
      let Base64 = {
        encode(str) {
          return btoa(
            encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function toSolidBytes(match, p1) {
              return String.fromCharCode('0x' + p1)
            })
          )
        },
        decode(str) {
          return decodeURIComponent(
            atob(str)
              .split('')
              .map(function(c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
              })
              .join('')
          )
        }
      }
      getAnnouncementTextApi(1).then(res => {
        res = res.data
        //console.info(res)
        // 将富文本的base64编码 转换成原来的格式，这个用于将数据库中的富文本展示在界面上
        //let Base64 = require('js-base64').Base64
        let decoded = Base64.decode(res.data)
        //console.info(decoded)
        this.textHtml =
          decoded +
          '<br>' +
          "<a href='https://esign.longshine.com/#/userAgreement' style='color: blue'>《用户协议》</a>" +
          //"<a href='https://esign.longshine.com:9080/#/userAgreement' style='color: blue'>《用户协议》</a>" +
          //"<a href='http://localhost:3333/#/userAgreement' style='color: blue'>《用户协议》</a>" +
          '<br>' +
          '<br>' +
          "<a href='https://esign.longshine.com/#/privacyPolicy' style='color: blue'>《隐私政策》</a>"
        //"<a href='https://esign.longshine.com:9080/#/privacyPolicy' style='color: blue'>《隐私政策》</a>"
        //"<a href='http://localhost:3333/#/privacyPolicy' style='color: blue'>《隐私政策》</a>"
      })
    },

    confirm() {
      this.isShow = false
      this.checked = true
      this.registerForm = true
    },
    refuse() {
      this.isShow = false
      this.checked = false
      this.$router.push({ name: 'login' })
    },

    authentic() {
      // this.$refs[formName].validate(valid => {
      //   if (valid) {
      //     //实名认证
      //     this.toAuth()
      //   } else {
      //     alert('填写信息有误，请检查!')
      //     return false
      //   }
      // })
      this.$router.push({ name: 'authentic' })
      //this.$router.push({ name: 'authentication' })
    },
    toLogin() {
      this.$router.push({ name: 'login' })
    },
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min)
    },
    refreshCode() {
      makeCodeApi().then(res => {
        //console.info(res.data)
        this.vcode_img = res.data.data
        this.verKey = res.data.msg
      })
    },
    toAuth() {
      var mobile = this.ruleForm.mobile
      console.info(mobile)
      //调用认证接口获取认证url
      getCompanyVerifyUrlApi(mobile, '', '').then(res => {
        res = res.data
        if (res.code === 0) {
          let url = res.data.url //base64加密的url
          let Base64 = require('js-base64').Base64
          let decodeUrl = Base64.decode(url) //解密的url
          //跳转至fdd认证页面url
          window.location.href = decodeUrl
        } else {
          this.$message({
            type: 'warning',
            message: res.msg
          })
        }
      })
    }
  },
  mounted() {
    this.refreshCode()
    this.getTest()
  }
}
</script>

<style lang="scss" scoped>
.el-form {
  // width: 420px;
  // margin: auto;
  // padding: 45px;
  // height: 610px;
  // background-color: #fff;
  // margin-left: 1000px;
  // margin-top: 50px;
  // border-radius: 15px;

  position: absolute;
  width: 420px;
  height: 610px;
  padding: 45px;
  top: 10%;
  right: 5%;
  background-color: #fff;
  border-radius: 15px;
}
.el-button {
  padding: 10px 5px;
}
.el-form-item__label {
  text-align: right;
  vertical-align: middle;
  float: left;
  font-size: 14px;
  color: #606266;
  line-height: 50px;
  padding: 10px 12px 0 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.el-checkbox {
  padding-left: 0px;
}
.refreshCode {
  cursor: pointer;
}
h5 {
  font-size: max($numbers: 25px);
  padding-bottom: 20px;
}
.index_background {
  width: 100%;
  height: 100%;
  background-image: url('../../assets/images/background1.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  -moz-background-size: 100% 100%;
}

element.style {
  margin-left: 30px;
}
.el-form-item__content {
  line-height: 40px;
  position: relative;
  font-size: 14px;
}
</style>

<style>
.checkbox {
  float: right;
}
</style>
